import { Switch, Route, Redirect } from "react-router-dom";

import Dashboard from "./Dashboard";
import TaskDetails from "./TaskDetails";
import StartTask from "./StartTask";
import DngUserLogin from "./DngUserLogin";
import DropNGoDashboard from "./DropNGoDashboard";

const StaffDashboard = () => {
	return (
		<div>
			<Switch>
				<Route exact path="/staff/dashboard" component={Dashboard} />
				<Route exact path="/staff/task/details" component={TaskDetails} />
				<Route exact path="/staff/task/start" component={StartTask} />
				<Route exact path="/staff/dng/login" component={DngUserLogin} />
				<Route exact path="/staff/dashboard/dropngo" component={DropNGoDashboard} />
				<Redirect to="/staff/dashboard" />
			</Switch>
		</div>
	);
};

export default StaffDashboard;